import * as React from "react";
import type { SVGProps } from "react";
const SvgNotification = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <g
      stroke="#2962FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#notification_svg__a)"
    >
      <path d="M9.066 13.333H6.933" />
      <path
        d="M11.334 6.688v-.022 0A3.334 3.334 0 0 0 8 3.333v0a3.334 3.334 0 0 0-3.333 3.333v1.67a.57.57 0 0 1-.315.509l-.335.167c-.419.21-.684.638-.684 1.106v0c0 .683.554 1.236 1.236 1.236h6.862c.683 0 1.236-.553 1.236-1.236v0c0-.468-.265-.896-.684-1.105l-.335-.167a.57.57 0 0 1-.314-.51z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="notification_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNotification;
